import React from "react";
import { Button, Pagination } from "@pd/pd-ui-kit";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import AddIcon from "~/components/Icons/svg/add";
import EditIcon from "~/components/Icons/svg/edit";
import HistoryIcon from "~/components/Icons/svg/history";
import CreateContract from "~/pages/ListOfDocuments/Modals/CreateContract";
import EditContract from "~/pages/ListOfDocuments/Modals/EditContract";
import HistoryContract from "~/pages/ListOfDocuments/Modals/HistoryContract";
import { useUpdateContract } from "~/entity/Contract";
import { useContractTableState } from "~/pages/ListOfDocuments/hooks/useContractTableState";
import { getListOfDocumentsColumns } from "~/pages/ListOfDocuments/model/tableAdapter";
import { REGISTER_OF_DOCS_OPTION } from "~/pages/ListOfDocuments/options";
import { TableV2 } from "~/shared/ui/TableV2";

import { AccessIProps } from "..";

import s from "~/pages/ListOfDocuments/styles.less";

const Contracts = ({ access }: { access: AccessIProps }) => {
  const { mutate } = useUpdateContract();
  const { t } = useTranslation();
  const {
    data,
    isLoading,
    page,
    count,
    typeModal,
    dealerObj,
    getEvent,
    handleCount,
    handlePage,
    closeModal,
    closeModalRefetch,
  } = useContractTableState("main");

  const handleDealerSignedDate = (data: any) => {
    mutate({
      data: {
        isSignedByDealer: true,
        dealerSignedDate: format(new Date(), "yyyy-MM-dd") + "T00:00:00Z",
      },
      id: data.contractId,
    });
  };

  const renderDealerSignedDate = (value: any, record: any) => {
    if (record?.dealerSignedDate) {
      return `${t("registryOfDocs.signedFrom")} ${value}`;
    }
    if (!record?.status) {
      return (
        <Button size="small" onClick={() => handleDealerSignedDate(record)}>
          {t("registryOfDocs.signedBtn")}
        </Button>
      );
    }
    return null;
  };

  const columns = getListOfDocumentsColumns(
    t,
    REGISTER_OF_DOCS_OPTION,
    renderDealerSignedDate,
  );

  return (
    <>
      <TableV2
        wrapperClassName={s.tableWrapper}
        columns={columns}
        dataSource={data?.formatData ?? []}
        rowKey={(record: any) =>
          record.contractId ? `c_${record.contractId}` : `d_${record.id}`
        }
        loading={isLoading}
        pagination={false}
        rowControlExtra={(record: any) => (
          <>
            {record.status && access.create && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => getEvent(record, "create")}
              >
                <AddIcon />
              </div>
            )}

            {!record.status && (
              <>
                {access.edit && (
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => getEvent(record, "edit")}
                  >
                    <EditIcon />
                  </div>
                )}
                {access.history && (
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => getEvent(record, "history")}
                  >
                    <HistoryIcon />
                  </div>
                )}
              </>
            )}
          </>
        )}
        actionsFixed
        scroll={{ x: "max-content" }}
      />
      <Pagination
        count={count}
        page={page + 1}
        totalCount={data?.totalCount ?? 0}
        onChangeCount={handleCount}
        onChangePage={handlePage}
      />
      {dealerObj && typeModal === "create" && (
        <CreateContract
          open
          onClose={closeModalRefetch}
          dealerObj={dealerObj}
        />
      )}
      {dealerObj && typeModal === "edit" && (
        <EditContract
          open
          onClose={closeModalRefetch}
          dealerObj={dealerObj}
          print={access.print}
        />
      )}
      {dealerObj && typeModal === "history" && (
        <HistoryContract open onClose={closeModal} dealerObj={dealerObj} />
      )}
    </>
  );
};

export default Contracts;
